export enum MouseButtonValue {
  Left = 0,
  Middle = 1,
  Right = 2,
  Back = 3,
  Forward = 4,
  Extra = -1
}
